module.exports = __webpack_public_path__ + "static/img/icon-ge-003.200874e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-ge-003.png
// module id = zpu7
// module chunks = 1